import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import MetricSeries from 'enums/MetricSeries'
import { getMetricDataset } from '../utils'

const NoMentionGuard: WidgetGuard = ({ widgetId, children }) => {
  const { data, dataIdx } = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()
  const { countIdx } = dataIdx!
  if (countIdx > 0) {
    // if having a seperated runsearch for mention
    const mentionsData = data[countIdx]
    const metricDataset = getMetricDataset(mentionsData, 0)
    if (metricDataset[0].set![0] === 0) {
      return <ErrorMessage>{t('noDataFilterSet')}</ErrorMessage>
    }
  } else {
    // if no seperated runsearch for mention
    const measureData = data[0]
    const metricDataset = getMetricDataset(measureData, 0)
    const mentionCount = metricDataset.find((item) => item.seriesName === MetricSeries.TOTAL_BUZZ)!
      .set![0]
    if (mentionCount === 0) {
      return <ErrorMessage>{t('noDataFilterSet')}</ErrorMessage>
    }
  }

  return children
}

export default NoMentionGuard
